<template>
  <div class="row">
    <div class="col-lg-6">
      <form-base
        :submit-status="submitStatus"
        action="Export TimeTattler"
        :errors="errors"
        :loading="loading"
        v-on:handleSubmit="handleSubmit('timeTattler')"
      >
        <template v-slot:fields>
          <h5 class="mt-3">Export Clockings</h5>
          <hr />

          <form-group label="Branch" :required="true">
            <b-form-select
              @blur="$v.clockings.branch_id.$touch"
              :class="{ 'is-invalid': $v.clockings.branch_id.$error }"
              v-model="clockings.branch_id"
              :options="branches"
              text-field="branch.name"
              value-field="branch_id"
            />
            <div
              class="invalid-feedback"
              v-if="!$v.clockings.branch_id.required"
            >
              Please select branch
            </div>
          </form-group>

          <form-group label="From" :required="true">
            <input
              type="date"
              v-model="clockings.from"
              class="form-control"
            />
              <div
              class="invalid-feedback"
              v-if="!$v.clockings.from.required"
            >
              Please select from
            </div>
          </form-group>

          <form-group label="To" :required="true">
            <input
              v-model="clockings.to"
              class="form-control"
              type="date"
            />
              <div
              class="invalid-feedback"
              v-if="!$v.clockings.to.required"
            >
              Please select To
            </div>
          </form-group>
        </template>

          <template v-slot:buttons>
            <span class="btn btn-secondary" @click="handleSubmit('report')">Report</span>
          </template>
      </form-base>
    </div>
  </div>
</template>

<script>
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import { required } from "vuelidate/lib/validators";
import clockingRepo from "@/api/repos/clockingRepo";

export default {
  components: {
    formBase,
    formGroup,
  },
  validations: {
    clockings: {
      branch_id: {
        required,
      },
      from:{
        required
      },
      to:{
        required
      }
    },
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      clockings: {},
      branches: [],
      loading: false,
      errors: null,
      submitStatus: null,
    };
  },
  methods: {
    async getData() {
      try {
        let { data } = await clockingRepo.exportGetData();
        this.branches = data.branches;

        
        if (this.branches.length == 0) {
          this.$root.$bvToast.toast(
            "You are not allocated as a Clerk to any branches.",
            {
              title: "No Clerk Branch Relations",
              autoHideDelay: 3000,
              variant: "danger",
            }
          );
        }

      } catch (error) {
        console.log(error);
      }
    },
    report(){
      this.handleSubmit('report');
    },
    async handleSubmit(reportType) {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
           this.clockings.report_type = reportType
           console.log("heheh")
           let response = await clockingRepo.export(this.clockings);
           var fileURL = window.URL.createObjectURL(new Blob([response.data]));
           var fileLink = document.createElement('a');
          
           fileLink.href = fileURL;
           fileLink.setAttribute('download',`clockings.csv`);
           document.body.appendChild(fileLink);
          
           fileLink.click();
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

<style>
</style>